<template>
  <div class="toastMask" v-show="visible">
    <div class="prizeDialog">
      <img :src="imgPath" class="wd">
      <div class="redpackWd" v-if="keyword&&keyword!=''">
        <img src="../keyword01.jpg" alt="" class="key01">
        <span class="wd">{{keyword}}</span>
        <img src="../keyword02.jpg" alt="" class="key02">
      </div>
      <div class="againBtn" @click="close"></div>
      <div class="close" @click="close"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    imgPath: {
      type: String,
      default: ""
    },
    keyword: {
      type: [String, Object],
      default: ''
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.toastMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
.prizeDialog {
  width: 692px;
  height: 552px;
  background: url("../dialogBg.jpg") #fff center top no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding-top: 329px;
  .redpackWd{
    font-size:0;
    vertical-align: top;
    text-align: center;
    .key01,.key02{
      width:auto;
      height:42px;
      display: inline-block;
    }
    .wd{
      font-size: 18px;
      color:#c29f83;
      vertical-align: top;
      padding:0 1px;
    }
  }
  .againBtn {
    cursor: pointer;
    width: 175px;
    height: 41px;
    background: url("../againBtn.jpg");
    margin: 0 auto;
  }
  .close {
    cursor: pointer;
    position: absolute;
    top: -40px;
    right: -40px;
    width: 39px;
    height: 39px;
    background: url("../close.png") center no-repeat;
    background-size: contain;
  }
}
</style>

